<div class="language-switcher"><div class="language" @click="switchLocale">{{ language }}</div></div>